import React from 'react'
import AppNavbar from '../components/Navbar/Navbar'
import Careers from '../components/Careers/Careers'
import Footer from '../components/Footer/Footer'

const CareersPage = () => {
  return (
    <div>
        <AppNavbar/>
        <Careers/>
        <Footer/>
    </div>
  )
}

export default CareersPage